import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";


// MODALS
import Modal from "../partials/Modal";
import useModal from "components/hooks/useModal";
import NewModal from "components/partials/NewModal";
import ModalVSConfigureScenario from "../Workshops/ModalVSConfigureScenario";
import ModalVSGeneralConfirmation from "../Workshops/ModalVSGeneralConfirmation";
import ModalVSConfirmationSent from "../Workshops/ModalVSConfirmationSent";
import ModalEPCISelection from "../Workshops/GeneralWorkshop/ModalEPCISelection";

const ModalSimValidation = ({ closeModal, onClick, results, values, jsonFile }) => {

  const [EPCISelection, setEPCISelection] = useState(null);
  const [workShopType, setWorkShopType] = useState(null);

  const [modalVSConfigureScenario, setModalVSConfigureScenario] = useState(false);
  const [modalVSGeneralConfirmation, setModalVSGeneralConfirmation] = useState(false);
  const [modalVSConfirmationSent, setModalVSConfirmationSent] = useState(false);

  const {isShowing: isModalEPCISelection, open: openModalEPCISelection, close: closeModalEPCISelection} = useModal();

  const handleOnlineShare = () => {
    setWorkShopType("online");
    openModalEPCISelection();
  };
  const handleWorkshopShare = () => {
    setWorkShopType("workshop");
    openModalEPCISelection();
  };
  const handleStepAfterEPCI = () => {
    if (workShopType === 'online') {
      setModalVSGeneralConfirmation(true);
    }
    else if (workShopType === 'workshop') {
      setModalVSConfigureScenario(true);
    }
  }


  return (
    <div className="modal-sim modal-validate flex-column">

      <NewModal
          isShowing={isModalEPCISelection}
          close={closeModalEPCISelection}
          width="800px"
        >
        <ModalEPCISelection
          EPCISelection={EPCISelection}
          setEPCISelection={setEPCISelection}
          close={closeModalEPCISelection}
          onNext={handleStepAfterEPCI}
        />
      </NewModal>

      <Modal
        isOpen={modalVSGeneralConfirmation}
        closeModal={() => setModalVSGeneralConfirmation(false)}
        okButton={false}
        >
        <ModalVSGeneralConfirmation
            closeModal={() => setModalVSGeneralConfirmation(false)}
            results={results}
            val={values}
            EPCISelection={EPCISelection}
            jsonFile={jsonFile}
        />
      </Modal>

      <Modal
        isOpen={modalVSConfigureScenario}
        closeModal={() => setModalVSConfigureScenario(false)}
        okButton={false}
        >
        <ModalVSConfigureScenario
            results={results}
            val={values}
            jsonFile={jsonFile}
            EPCISelection={EPCISelection}
            closeModal={() => setModalVSConfigureScenario(false)}
            setModalVSConfirmationSent={setModalVSConfirmationSent}
        />
      </Modal>

      <Modal
        isOpen={modalVSConfirmationSent}
        closeModal={() => setModalVSConfirmationSent(false)}
        okButton={false}
        >
        <ModalVSConfirmationSent closeModal={() => setModalVSConfirmationSent(false)} />
      </Modal>

      <h2 className="container_title">Que voulez-vous faire ?</h2>

      <Link className="btn primary-btn" to={{ pathname: "/results", state: { results } }}>
        Voir les résultats complets
      </Link>

      <button
        type="button"
        className="btn primary-btn"
        onClick={handleOnlineShare}
      >
        Je suis <b>en ligne</b><br/>je partage mon scénario
      </button>

      <button
        type="button"
        className="btn primary-btn"
        onClick={handleWorkshopShare}
      >
        Je suis dans <b>un atelier</b><br/>je partage mon scénario
      </button>

      <button className="btn secondary-btn close-btn" type="button" onClick={() => closeModal()}>
        Annuler
      </button>
    </div>
  );
};

export default ModalSimValidation;
